<template>
  <div class="approval_flow">
    <a-row>
      <a-col :xs="6" :sm="4" style="text-align: right; margin-bottom: 16px;">审批流程：</a-col>
      <a-col :xs="24" :sm="10">
        <div style="cursor:pointer;color: #0295EE;margin-bottom: 16px;" v-if="hasBtn" @click="fetchApprovalFlow">{{params.length===0?'加载审批流':'刷新审批流'}}</div>
        <span v-if="!hasBtn && params.length===0" style="font-size: 14px;color: rgba(0,0,0,0.38);">{{initText}}</span>
        <a-timeline v-if="params.length>0">
          <a-timeline-item :color="setStatusColor(item.status)" v-for="(item,index) in params" :key="index">
            <h6 v-if="item.type == 'comment'">评论</h6>
            <h6 v-else>{{item.step_name}}</h6>
            <div v-if="item.type == 'comment'" class="detail comment-detail">
              <span class="detail-username">{{item.user_name}}</span>
              <span class="detail-date">{{item.content}}</span>
              <p class="detail-user" v-if="item.notice_user_name.length">
                <span v-for="i in item.notice_user_name" :key="i">@{{i}} </span>
              </p>
              <div class="detail-attachment">
                <p class="detail-date">{{item.created_at}}</p>
                <div class="detail-attachment-item" v-for="i in item.attachment" :key="i.name + 1">
                  <img v-if="i.isImage" src="/images/file-image.svg" alt="" srcset="">
                  <img v-if="!i.isImage" src="/images/file-default.svg" alt="" srcset="">
                  <span>{{i.name}}</span>
                  <a :href="i.url" :download="i.url">下载</a>
                </div>
              </div>
            </div>
            <div v-else class="detail">
              <span class="detail-username">{{item.approver}}</span>
              <span class="detail-date">{{item.comments}}</span>
              <span class="detail-date">{{item.time}}</span>
            </div>
          </a-timeline-item>
          <!-- <a-timeline-item color="red">
            <p>Solve initial network problems 1</p>
            <p>Solve initial network problems 2</p>
            <p>Solve initial network problems 3 2015-09-01</p>
          </a-timeline-item>
          <a-timeline-item color="#8B9AAD">
            <p>Solve initial network problems 1</p>
            <p>Solve initial network problems 2</p>
            <p>Solve initial network problems 3 2015-09-01</p>
          </a-timeline-item> -->
        </a-timeline>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CommonForm from "./CommonForm.vue";

export default {
  components: {},
  props: {
    layout: Object,
    params: Array,
    initText: String,
    hasBtn: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    setStatusColor(status) {
      if (status === 1) {
        return "orange";
      } else if (status === 2 || status === 10) {
        return "green";
      } else if (status === 3 || status === 11) {
        return "red";
      } else if (status === undefined) {
        return "blue";
      } else {
        return "gray";
      }
    },
    fetchApprovalFlow() {
      this.$emit("fetch-flow");
    }
  },
  watch: {
    params: {
      handler(val) {},
      deep: true
    }
  }
};
</script>

<style lang="less">
.approval_flow {
  .ant-timeline {
    &-item {
      &-head-green {
        background: #52c41a;
      }
      &-head-red {
        background: #f5222d;
      }
      &-head-orange {
        background: orange;
        // background: #f5222d;
      }
      &-head-blue {
        background: #1890ff;
      }
      &-head-gray {
        background: #8b9aad;
        border-color: #8b9aad !important;
      }
      &-content {
        h6 {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.87);
        }
        .detail {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          &-date {
            color: rgba(0, 0, 0, 0.38);
            margin-left: 8px;
          }
        }
        .comment-detail {
          .detail-user {
            margin-bottom: 0px;
          }
          .detail-attachment {
            &-item {
              display: block;
              max-width: 260px;
              padding: 6px;
              margin-bottom: 10px;
              background: #ffffff;
              border: 1px solid #dedede;
              border-radius: 4px;
              &:last-child {
                margin-bottom: 0;
              }
              span {
                display: inline-block;
                max-width: 150px;
                margin: 0 4px;
                line-height: 22px;
                margin-bottom: -6px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              a {
                display: inline-block;
                width: 38px;
                line-height: 22px;
                background: #ffffff;
                border: 1px solid #dedede;
                border-radius: 4px;
                font-size: 12px;
                color: rgba(0, 0, 0, 0.65);
                text-align: center;
              }
            }
            .detail-date {
              color: rgba(0, 0, 0, 0.65);
              margin-left: 0px;
              margin-bottom: 6px;
            }
          }
        }
      }
    }
  }
}
</style>
